export const documentTypes = [
	{
		color: "primary",
		title: "blue",
	},
	{
		color: "secondary",
		title: "gray",
	},
	{
		color: "success",
		title: "green",
	},
	{
		color: "danger",
		title: "red",
	},
	{
		color: "warning",
		title: "yellow",
	},
	{
		color: "info",
		title: "light blue",
	},
];
export const bootstrapColors = [
	{
		color: "primary",
		title: "blue",
	},
	{
		color: "secondary",
		title: "gray",
	},
	{
		color: "success",
		title: "green",
	},
	{
		color: "danger",
		title: "red",
	},
	{
		color: "warning",
		title: "yellow",
	},
	{
		color: "info",
		title: "light blue",
	},
];
export const primeIcons = [
	"pi-angle-up",
	"pi-arrow-right-arrow-left",
	"pi-asterisk",
	"pi-at",
	"pi-ban",
	"pi-barcode",
	"pi-bell",
	"pi-bolt",
	"pi-book",
	"pi-bookmark",
	"pi-box",
	"pi-briefcase",
	"pi-building",
	"pi-building-columns",
	"pi-bullseye",
	"pi-calculator",
	"pi-calendar",
	"pi-camera",
	"pi-car",
	"pi-chart-bar",
	"pi-chart-line",
	"pi-chart-pie",
	"pi-check-circle",
	"pi-check-square",
	"pi-clipboard",
	"pi-clock",
	"pi-clone",
	"pi-code",
	"pi-cog",
	"pi-comment",
	"pi-comments",
	"pi-compass",
	"pi-copy",
	"pi-credit-card",
	"pi-crown",
	"pi-database",
	"pi-delete-left",
	"pi-desktop",
	"pi-dollar",
	"pi-download",
	"pi-eject",
	"pi-envelope",
	"pi-euro",
	"pi-exclamation-circle",
	"pi-exclamation-triangle",
	"pi-eye",
	"pi-face-smile",
	"pi-file",
	"pi-file-arrow-up",
	"pi-file-check",
	"pi-file-edit",
	"pi-file-excel",
	"pi-file-export",
	"pi-file-import",
	"pi-file-pdf",
	"pi-file-plus",
	"pi-file-word",
	"pi-flag",
	"pi-folder",
	"pi-folder-open",
	"pi-folder-plus",
	"pi-gauge",
	"pi-gift",
	"pi-globe",
	"pi-graduation-cap",
	"pi-hammer",
	"pi-hashtag",
	"pi-headphones",
	"pi-heart",
	"pi-history",
	"pi-home",
	"pi-hourglass",
	"pi-id-card",
	"pi-image",
	"pi-images",
	"pi-inbox",
	"pi-indian-rupee",
	"pi-info-circle",
	"pi-key",
	"pi-language",
	"pi-lightbulb",
	"pi-link",
	"pi-lock",
	"pi-map",
	"pi-map-marker",
	"pi-mars",
	"pi-megaphone",
	"pi-microchip",
	"pi-microphone",
	"pi-mobile",
	"pi-money-bill",
	"pi-objects-column",
	"pi-palette",
	"pi-paperclip",
	"pi-pen-to-square",
	"pi-pencil",
	"pi-percentage",
	"pi-phone",
	"pi-play-circle",
	"pi-plus-circle",
	"pi-pound",
	"pi-power-off",
	"pi-print",
	"pi-qrcode",
	"pi-question",
	"pi-question-circle",
	"pi-receipt",
	"pi-refresh",
	"pi-replay",
	"pi-reply",
	"pi-save",
	"pi-search",
	"pi-send",
	"pi-server",
	"pi-share-alt",
	"pi-shield",
	"pi-shop",
	"pi-shopping-bag",
	"pi-shopping-cart",
	"pi-sitemap",
	"pi-sliders-h",
	"pi-sliders-v",
	"pi-sparkles",
	"pi-spinner-dotted",
	"pi-star",
	"pi-stop-circle",
	"pi-stopwatch",
	"pi-sync",
	"pi-table",
	"pi-tablet",
	"pi-tag",
	"pi-th-large",
	"pi-ticket",
	"pi-times-circle",
	"pi-trash",
	"pi-trophy",
	"pi-undo",
	"pi-upload",
	"pi-user",
	"pi-venus",
	"pi-video",
	"pi-wallet",
	"pi-warehouse",
	"pi-wave-pulse",
	"pi-wifi",
	"pi-wrench",
];
